import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { authService } from "../services/auth-service";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        authService.me()
            .then((data) => setUser(data.user))
            .catch(() => setUser(null))
            .finally(() => setLoading(false));
    }, []);

    const value = useMemo(() => ({
        user,
        loading,
        async login(payload) {
            const data = await authService.login(payload);
            setUser(data.user);
            return data.user;
        },
        async register(payload) {
            const data = await authService.register(payload);
            setUser(data.user);
            return data.user;
        },
        async updateProfile(payload) {
            const data = await authService.updateProfile(payload);
            setUser(data.user);
            return data.user;
        },
        async deleteProfile() {
            await authService.deleteProfile();
            setUser(null);
        },
        async uploadAvatar(file) {
            const data = await authService.uploadAvatar(file);
            setUser(data.user);
            return data.user;
        },
        async changePassword(payload) {
            return authService.changePassword(payload);
        },
        async logout() {
            await authService.logout();
            setUser(null);
        },
        async returnToAdmin() {
            const data = await authService.returnToAdmin();
            setUser(data.user);
            return data.user;
        }
    }), [user, loading]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const value = useContext(AuthContext);
    if (!value) {
        throw new Error("useAuth must be used inside AuthProvider");
    }
    return value;
}
